// extracted by mini-css-extract-plugin
module.exports = {"pageLoadimg":"components-base-PageLoading-PageLoading__pageLoadimg--2p4ZT"};